"use client";

import { isReservationTicketWorkflow } from "@gettactic/api";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { api } from "@/lib/api/api";

export const useWorkplaceRequestWorkflowsKey = "workplaceRequestWorkflows";

/**
 * The workflows a pending request would run on approval, each with the values
 * core resolved from it. Only fetched for a pending request the viewer can
 * approve: that is the one moment the values are editable, and approving moves
 * the request out of `pending`, which disables the query on its own.
 */
export function useWorkplaceRequestWorkflows(
  ticketId: string,
  isEnabled: boolean
) {
  const query = useQuery({
    queryKey: [useWorkplaceRequestWorkflowsKey, ticketId],
    queryFn: async () => {
      const res =
        await api.client.workplaceRequests.getWorkplaceRequestWorkflows(
          ticketId
        );
      return res.result ?? [];
    },
    enabled: isEnabled && !!ticketId
  });

  const reservationWorkflows = useMemo(
    () => (query.data ?? []).filter(isReservationTicketWorkflow),
    [query.data]
  );

  return {
    workflows: query.data ?? [],
    reservationWorkflows,
    // `isLoading` alone would report a disabled query as loading forever.
    isLoading: isEnabled && query.isLoading,
    error: query.error
  };
}
